import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-57d2e7bc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "pblWindow"
};
const _hoisted_2 = {
  id: "containRelics",
  ref: "contain"
};
const _hoisted_3 = {
  key: 0,
  class: "360Img"
};
const _hoisted_4 = {
  class: "imgbox",
  id: "imgbox"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "threesixty"
}, [/*#__PURE__*/_createElementVNode("div", {
  id: "spinner"
}, [/*#__PURE__*/_createElementVNode("span", null, "0%")]), /*#__PURE__*/_createElementVNode("ol", {
  id: "threesixty_images"
})], -1));
const _hoisted_7 = ["value"];
const _hoisted_8 = {
  key: 2,
  class: "containRelicsImg"
};
const _hoisted_9 = {
  class: "imagslist"
};
const _hoisted_10 = {
  class: "swiper-container swiperImg",
  ref: "swiperImg"
};
const _hoisted_11 = {
  class: "swiper-wrapper"
};
const _hoisted_12 = {
  class: "swiper-slide"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  class: "swiper-button-next swiper-button-white"
};
const _hoisted_15 = {
  class: "swiper-button-prev swiper-button-white"
};
const _hoisted_16 = {
  class: "containRelicsVideo"
};
const _hoisted_17 = ["src"];
const _hoisted_18 = ["src"];
const _hoisted_19 = {
  key: 4,
  id: "loadbar1"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  id: "bar1",
  style: {
    "width": "1%"
  }
}, null, -1));
const _hoisted_21 = [_hoisted_20];
const _hoisted_22 = {
  id: "containIntroduce"
};
const _hoisted_23 = ["innerHTML"];
const _hoisted_24 = {
  class: "zhuantiCode",
  ref: "zhuantiCode"
};
const _hoisted_25 = {
  key: 0,
  class: "list"
};
const _hoisted_26 = ["src"];
const _hoisted_27 = {
  class: "tips"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  id: "relics"
}, "文物", -1));
const _hoisted_29 = [_hoisted_28];
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  id: "introduce"
}, "简介", -1));
const _hoisted_31 = [_hoisted_30];
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  id: "special"
}, " 专题", -1));
const _hoisted_33 = [_hoisted_32];
const _hoisted_34 = {
  class: "titleCode"
};
const _hoisted_35 = {
  class: "title"
};
const _hoisted_36 = {
  class: "titleName"
};
const _hoisted_37 = {
  class: "code"
};
const _hoisted_38 = {
  id: "qrcode",
  ref: "erWeiMaCode"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "modelPlaceholder",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.hideModel && $options.hideModel(...args))
  }), _createElementVNode("div", {
    class: "model",
    style: _normalizeStyle(`top: ${$data.endMoveY ? $data.endMoveY : $data.boxTop}px`),
    ref: "model",
    onTouchstart: _cache[6] || (_cache[6] = (...args) => $options.modeltouchstart && $options.modeltouchstart(...args)),
    onTouchmove: _cache[7] || (_cache[7] = (...args) => $options.modeltouchmove && $options.modeltouchmove(...args))
  }, [_createElementVNode("div", {
    class: "close",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.hideModel && $options.hideModel(...args))
  }), _createElementVNode("div", {
    class: "contain",
    id: "contain3D",
    style: _normalizeStyle($props.modelData.type == '360' ? 'z-index: 0' : '')
  }, [_withDirectives(_createElementVNode("div", _hoisted_2, [$props.modelData.type == '360' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.detail.images360, item => {
    return _openBlock(), _createElementBlock("li", null, [_createElementVNode("img", {
      src: item
    }, null, 8, _hoisted_5)]);
  }), 256))])]), _hoisted_6])) : _createCommentVNode("", true), $data.detail.images360 && $data.detail.images360.length ? (_openBlock(), _createElementBlock("input", {
    key: 1,
    type: "hidden",
    id: "360Number",
    value: $data.detail.images360.length
  }, null, 8, _hoisted_7)) : _createCommentVNode("", true), $data.detail.type == '图片' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.detail.images, item => {
    return _openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("img", {
      src: item
    }, null, 8, _hoisted_13)]);
  }), 256))]), _withDirectives(_createElementVNode("div", _hoisted_14, null, 512), [[_vShow, $data.detail.images.length > 1]]), _withDirectives(_createElementVNode("div", _hoisted_15, null, 512), [[_vShow, $data.detail.images.length > 1]])], 512)])])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_16, [_createElementVNode("video", {
    controls: "",
    src: $data.detail.video
  }, null, 8, _hoisted_17)], 512), [[_vShow, $props.modelData.type == '视频']]), $props.modelData.type == '3D' ? (_openBlock(), _createElementBlock("iframe", {
    key: 3,
    frameborder: "0",
    border: "0",
    src: $props.detailUrl,
    width: "100%",
    height: "100%",
    style: _normalizeStyle(`z-index: ${$data.loadingIframe ? '-1' : '1'}`),
    id: "detailIframe"
  }, null, 12, _hoisted_18)) : _createCommentVNode("", true), $props.modelData.type == '3D' ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21)) : _createCommentVNode("", true)], 512), [[_vShow, $data.showDetail]]), _withDirectives(_createElementVNode("div", _hoisted_22, [$data.activeIndex == 1 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "content",
    innerHTML: $data.detail.description
  }, null, 8, _hoisted_23)) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_24, null, 512), [[_vShow, $data.activeIndex == 2]])], 512), [[_vShow, !$data.showDetail]]), $data.detail.audio ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createElementVNode("div", {
    id: "but",
    class: _normalizeClass(!$data.isPause ? 'but' : 'butno'),
    onClick: _cache[2] || (_cache[2] = (...args) => $options.handelAudio && $options.handelAudio(...args))
  }, null, 2), _createElementVNode("audio", {
    id: "voice",
    src: $data.detail.audio,
    ref: "audioItem"
  }, null, 8, _hoisted_26)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", {
    class: _normalizeClass(`relics ${$data.activeIndex == 0 ? 'active' : ''}`),
    onClick: _cache[3] || (_cache[3] = $event => $options.changeActive(0))
  }, _hoisted_29, 2), _createElementVNode("div", {
    class: _normalizeClass(`introduce ${$data.activeIndex == 1 ? 'active' : ''}`),
    onClick: _cache[4] || (_cache[4] = $event => $options.changeActive(1))
  }, _hoisted_31, 2), $data.detail.zhuanti ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(`special ${$data.activeIndex == 2 ? 'active' : ''}`),
    onClick: _cache[5] || (_cache[5] = $event => $options.changeActive(2))
  }, _hoisted_33, 2)) : _createCommentVNode("", true)])], 4), _createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, _toDisplayString($props.modelData.name), 1)]), _createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, null, 512)])])], 36)]);
}